/** Nomes canônicos de eventos (facade + MySQL + GA4). */
export const AnalyticsEventNames = {
  PAGE_VIEW: 'page_view',
  GUIDE_VIEWED: 'guide_viewed',
  GUIDE_UPDATED: 'guide_updated',
  POWER_VIEWED: 'power_viewed',
  POWER_OPEN: 'open_power',
  POWER_VIEW_SMILIES: 'view_smilies',
  SEARCH_PERFORMED: 'search',
  SEARCH_WITHOUT_RESULTS: 'search_zero',
  ARTICLE_LIKED: 'article_liked',
  CATEGORY_OPENED: 'category_opened',
  WORKSPACE_CARD_CREATED: 'workspace_card_created',
  WORKSPACE_CARD_COMPLETED: 'workspace_card_completed',
  WORKSPACE_COMMENT_ADDED: 'workspace_comment_added',
  CMS_LOGIN: 'cms_login',
  CMS_LOGOUT: 'cms_logout',
  CMS_PUBLISH: 'cms_publish',
  CMS_DELETE: 'cms_delete',
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEventNames)[keyof typeof AnalyticsEventNames];

export type AnalyticsEntityType = 'guide' | 'power' | 'category' | 'workspace' | 'user' | 'search';

export type BaseAnalyticsPayload = {
  path?: string;
  referrer?: string;
  channel?: string;
  device?: 'desktop' | 'mobile' | 'tablet' | string;
  title?: string;
};

export type GuideViewedPayload = BaseAnalyticsPayload & {
  guideId?: string | number;
  categorySlug?: string;
  slug?: string;
};

export type PowerViewedPayload = BaseAnalyticsPayload & {
  powerId?: string | number;
  slug?: string;
  action?: 'view' | 'open_power' | 'view_smilies';
};

export type SearchPayload = BaseAnalyticsPayload & {
  query: string;
  resultCount?: number;
};

export type CmsPayload = BaseAnalyticsPayload & {
  guideId?: string | number;
  action?: string;
  userId?: string | number;
};

export type WorkspacePayload = BaseAnalyticsPayload & {
  boardId?: string | number;
  cardId?: string | number;
};

export type AnalyticsEventPayloadMap = {
  page_view: BaseAnalyticsPayload;
  guide_viewed: GuideViewedPayload;
  guide_updated: GuideViewedPayload;
  power_viewed: PowerViewedPayload;
  open_power: PowerViewedPayload;
  view_smilies: PowerViewedPayload;
  search: SearchPayload;
  search_zero: SearchPayload;
  article_liked: GuideViewedPayload;
  category_opened: BaseAnalyticsPayload & { categoryId?: string; categorySlug?: string };
  workspace_card_created: WorkspacePayload;
  workspace_card_completed: WorkspacePayload;
  workspace_comment_added: WorkspacePayload;
  cms_login: CmsPayload;
  cms_logout: CmsPayload;
  cms_publish: CmsPayload;
  cms_delete: CmsPayload;
};

export type TrackEventInput<T extends AnalyticsEventName = AnalyticsEventName> = {
  event: T;
  payload?: T extends keyof AnalyticsEventPayloadMap
    ? AnalyticsEventPayloadMap[T]
    : Record<string, unknown>;
  sessionId?: string;
  visitorId?: string;
};
